import { IsActiveMatchOptions, Params, QueryParamsHandling } from '@angular/router';
import { HiddenOptions } from 'app/mock-api/common/navigation/data';

export interface DevstroupeNavigationItem {
    id?: string;
    title?: string;
    subtitle?: string;
    type: 'aside' | 'basic' | 'collapsable' | 'divider' | 'group' | 'spacer';
    hidden?: (item: HiddenOptions) => boolean;
    active?: boolean;
    disabled?: boolean;
    tooltip?: string;
    link?: string;
    fragment?: string;
    preserveFragment?: boolean;
    queryParams?: Params | null;
    queryParamsHandling?: QueryParamsHandling | null;
    externalLink?: boolean;
    target?: '_blank' | '_self' | '_parent' | '_top' | string;
    exactMatch?: boolean;
    isActiveMatchOptions?: IsActiveMatchOptions;
    function?: (item: DevstroupeNavigationItem) => void;
    classes?: {
        title?: string;
        subtitle?: string;
        icon?: string;
        wrapper?: string;
    };
    icon?: string;
    badge?: {
        title?: string;
        classes?: string;
    };
    children?: DevstroupeNavigationItem[];
    meta?: any;
}

export type DevstroupeVerticalNavigationAppearance = 'classic' | 'compact' | 'dense' | 'thin';

export type DevstroupeVerticalNavigationMode = 'over' | 'side';

export type DevstroupeVerticalNavigationPosition = 'left' | 'right';
